import React from 'react';
import { Text } from './core';
import { CopyIcon } from './icons';
import { MouseoverTooltip } from './Tooltip';
import type { BoxProps } from 'theme-ui';
import { isAddress, shortenAddress, copyToClipboard } from '@sc1/common';

interface ShortenedAddressProps extends BoxProps {
  address?: string;
  displayString?: string;
  characters?: number;
  copy?: boolean;
}

export const ShortenedAddress = ({
  address,
  displayString,
  characters,
  sx,
  ...more
}: ShortenedAddressProps): JSX.Element => {
  const checksummedAddress = address && isAddress(address);
  if (!checksummedAddress) return <Text>{address}</Text>;
  return (
    <Text>
      <MouseoverTooltip placement="top" width="auto" text={checksummedAddress}>
        <Text
          sx={{ cursor: 'pointer', ...sx }}
          {...more}
          onClick={() => copyToClipboard(checksummedAddress)}
        >
          <Text mr={1}>
            {displayString
              ? displayString
              : shortenAddress(checksummedAddress, characters)}
          </Text>
          <CopyIcon />
        </Text>
      </MouseoverTooltip>
    </Text>
  );
};
